module.exports = __webpack_public_path__ + "60589b39565bdbee778ef98465af390e.pdf";